import modalListTemplate from '../reimbursement/view/modalList.html'

class deductionDetailCtrl {
    constructor($scope, $uibModal, logger, httpRequest, $state, $stateParams) {
        // 隐藏一二级菜单
        if ($state.current.name === 'workspace.item.reiburseInfo') {
            $('#wrapper').addClass('invoiceDetailPage')
            $scope.$on('$stateChangeStart', () => {
                $('#wrapper').removeClass('invoiceDetailPage')
            })
        }
        const { expenseId } = $stateParams
        $scope.ivatExpenseBillRMap = []
        $scope.reimburseFrom = []
        $scope.listdata = []

        httpRequest.get_dictByTypeArr(['ivat_inv_type']).then((res) => {
            $scope.dictionary = res.data.value
        })

        httpRequest.get_getExpenseDetailById({ expenseId }).then((res) => {
            if (res.data.success) {
                $scope.reimburseFrom = res.data.value
                $scope.listdata = res.data.value.ivatExpenseBillRList
                const map1 = res.data.value.ivatExpenseBillRMap
                for (const item in map1) {
                    const obj = {
                        title: item,
                        list: map1[item],
                    }
                    $scope.ivatExpenseBillRMap.unshift(obj)
                }
                // console.log("属性：" + key + ",值：" + map[key]);
            }
        })
        // 抵扣属期
        $scope.datePickerConfig = {
            format: 'yyyymm',
            startView: 'year',
            minView: 'year',
            // endDate: new Date()
        }
        // 查询报销类型
        $scope.reimburseType = []
        $scope.smallType = []
        httpRequest.get_getIvatBxPzDTOList(true).then((res) => {
            const allType = res.data.value
            for (let i = 0; i < allType.length; i++) {
                const obj = {
                    enumName: allType[i].expenseName,
                    enumCode: allType[i].confId,
                }
                for (let j = 0; j < allType[i].mxList.length; j++) {
                    const obj2 = {
                        enumName: allType[i].mxList[j].expenseName,
                        enumCode: allType[i].mxList[j].confId,
                    }
                    $scope.smallType.push(obj2)
                }
                $scope.reimburseType.push(obj)
            }
        })
        $scope.showDetail = function (clickItem) {
            let currentList = []// 当前顺序的票面列表
            for (let j = 0, len = $scope.ivatExpenseBillRMap.length; j < len; j++) {
                currentList = currentList.concat($scope.ivatExpenseBillRMap[j].list ? $scope.ivatExpenseBillRMap[j].list : [])
            }
            $uibModal.open({
                template: modalListTemplate,
                controller: 'modalListCtrl',
                backdrop: 'static',
                openedClass: 'mod-modal-haslist mod-modal mod-modal-lg modal-reimburse-invoice-detail collection-invoice-detail',
                resolve: {
                    items1() {
                        const data = {
                            modalListData: currentList,
                            currentInvoicId: clickItem.invoiceId,
                        }
                        return data
                    },
                },
            })
        }
        $scope.savedeductDate = function () {
            if (!$scope.reimburseFrom.deductionDate) {
                logger.logError('请选择抵扣属期')
                return
            }
            httpRequest.get_batchSettingDeductionDate({
                expenseIds: [expenseId],
                period: $scope.reimburseFrom.deductionDate,
            }).then(() => {
                logger.logSuccess('设置成功')
                $state.go('input.reimburseManage.deduction.list')
            })
        }
        $scope.cancel = function () {
            $state.go('input.reimburseManage.deduction.list')
        }
    }
}
deductionDetailCtrl.$inject = ['$scope', '$uibModal', 'logger', 'httpRequest', '$state', '$stateParams']
export default deductionDetailCtrl



// WEBPACK FOOTER //
// ./src/app/input/reimburseManage/deduction/deductionDetailCtrl.js